import React, { useEffect, useState } from 'react';
import MenuManagementList from './MenuManagementList';
import { Button } from 'react-bootstrap';
import AddMenuManagement from './AddMenuManagement';
import { useMenuManagement } from '../../../context/MenuManagementContext';
import ReactPaginate from "react-paginate";
const MenuManagement = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("create"); // create | edit
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { loading, menuDataList, fetchMenuList, setMenuId, menuId } = useMenuManagement();
  const handleOpenCreate = () => {
    setModalType("create");
    setSelectedMenu(null);
    setShowModal(true);
  };

  const handleOpenEdit = (menuData, id) => {
    setMenuId(id)
    setModalType("edit");
    setSelectedMenu(menuData);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedMenu(null);
  };
  const handlePageChange = (event) => {
    // Adjusting for zero-based index by adding 1
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };
 useEffect(() => {
        fetchMenuList(perPage, currentPage);
    }, [perPage, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, []);
  return (
    <>
      <div className="col-12">
        <div className="card">
          <div className="card-header d-flex justify-content-end">
            <div>
              <Button
                variant="primary"
                className="mx-2"
                onClick={handleOpenCreate}
              >
                Add Menu <i className="fa fa-plus"></i>
              </Button>
              {showModal && (
                <AddMenuManagement
                  show={showModal}
                  handleClose={handleClose}
                  type={modalType}
                  editData={selectedMenu}
                  currentPage={currentPage}
                  perPage={perPage}
                  setCurrentPage={setCurrentPage}

                />
              )}
            </div>
          </div>
          <MenuManagementList handleOpenEdit={handleOpenEdit} currentPage={currentPage} perPage={perPage} />

        </div>

      </div>
      <ReactPaginate
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={8}
        marginPagesDisplayed={2}
        pageCount={Math.ceil(menuDataList?.pagination?.total / perPage)}
        previousLabel="< previous"
        pageClassName="page-item mx-1 my-1"
        pageLinkClassName="page-link"
        previousClassName="page-item mx-1 my-1"
        previousLinkClassName="page-link"
        nextClassName="page-item mx-1 my-1"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item mx-1 my-1"
        breakLinkClassName="page-link"
        containerClassName="pagination d-flex flex-wrap "
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />

    </>
  );
}

export default MenuManagement;
